export default "__VITE_ASSET__CMzc64Ec__"